import { DeviceForAPI } from 'src/app/services/data/devices-data/devices-data.types';
import { ExportRow } from '@portal/shared/types/export.types';

export const mapDcuDeviceToExport = (dcu: DeviceForAPI, formatDate: (date: string) => string): ExportRow =>
  ({
    deviceId: { title: 'CommDeviceID', value: dcu.deviceId },
    deviceTypeName: { title: 'DeviceType', value: dcu.deviceTypeName },
    modelName: { title: 'ModelName', value: dcu.modelName },
    status: { title: 'Status', value: dcu.status },
    dcuCommunicationStatus: { title: 'CommunicationStatus', value: dcu.dcuCommunicationStatus },
    deviceStatusValue: { title: 'DeviceHealth', value: dcu.deviceStatusValue },
    lastHeard: { title: 'LastHeard', value: dcu.lastHeard ? formatDate(dcu.lastHeard) : '' },
    batteryStatus: { title: 'BatteryStatus', value: dcu.batteryStatus },
    deviceNameCustom: { title: 'DeviceName', value: dcu.deviceNameCustom },
    deviceLocationCustom: { title: 'DCULocation', value: dcu.deviceLocationCustom },
    powerSupplyBoardFw: { title: 'PowerSupplyBoardFw', value: dcu.powerSupplyBoardFw },
    mainBoardFW: { title: 'MainBoardFw', value: dcu.mainBoardFw },
    slot1Fw: { title: 'Slot1Fw', value: dcu.slot1Fw },
    slot2Fw: { title: 'Slot2Fw', value: dcu.slot2Fw },
    slot3Fw: { title: 'Slot3Fw', value: dcu.slot3Fw },
    location: [
      { title: 'Latitude', value: dcu.geoMetaData?.latitude ?? '' },
      { title: 'Longitude', value: dcu.geoMetaData?.longitude ?? '' },
      { title: 'Comment', value: dcu.geoMetaData?.comments ?? '' }
    ]
  }) as ExportRow;
